export default __webpack_public_path__ + "static/media/plus.8bd209fc.svg";